import { useLayoutEffect } from 'react';

const useScrollToPosition = (elementId = null, offset = 0) => {
  useLayoutEffect(() => {
    const executeScroll = () => {
      if (elementId) {
        const element = document.getElementById(elementId);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition + offset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    };

    const timer = setTimeout(() => {
      executeScroll();
    }, 100);

    return () => clearTimeout(timer);
  }, [elementId, offset]);
};

export default useScrollToPosition;